import { Card, CardBody, Col } from "reactstrap";
import { FeatherIcons, H4, SVG } from "../../../../AbstractElements";
import { bitcoinData } from "../../../../Data/Widgets/GeneralWidgetsData";
import ReactApexChart from "react-apexcharts";

const BitcoinCurrency = () => {
  return (
    <>
      {bitcoinData.map((data,i)=>(
        <Col sm="4" xxl="2" key={i}>
          <div className={`currency-widget ${data.class} height-equal widget-currency`}>
            <div className="d-flex">
              <div className="currency-icon-widget">
                <SVG iconId={data.svg} />
              </div>
              <div>
                <H4>
                  {data.title} <span className="f-light">{data.titleSub}</span>
                </H4>
              </div>
            </div>
            <Card>
              <CardBody className="d-flex">
                <div className="currency-chart-wrap">
                  <ReactApexChart options={data.chart} series={data.chart.series} type={"line"} height={120} />
                </div>
                <div className={`bg-light-${data.class} text-center`}>
                  <H4 className="mb-sm-0">{data.amount}</H4>
                  <span className={`f-12 f-w-500 font-${data.class}`}>
                    <FeatherIcons className="me-1" iconName="TrendingUp" />
                    {data.percentage}
                  </span>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      ))}
    </>
  );
};

export default BitcoinCurrency;
